import React from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { GrippAuthLogo } from './GrippAuthLogo';
import { Colors } from '@gripp/shared-ui';

type Props = {
  children: React.ReactNode;
  topBar?: React.ReactNode;
};

export const AuthSplitLayout = ({ children, topBar }: Props) => {
  return (
    <View style={styles.container}>
      <View style={styles.left}>
        {topBar != null && <View style={styles.topBarContainer}>{topBar}</View>}
        <View style={styles.formCenter}>
          <View style={styles.formWrapper}>{children}</View>
        </View>
        <Text style={styles.footer}>support@gripp.ag</Text>
      </View>
      <View
        style={[
          styles.right,
          {
            backgroundImage: 'url(/login-image.webp)',
            backgroundSize: 'cover',
          } as any,
        ]}
      >
        <GrippAuthLogo />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: Colors.role.surface,
    padding: 16,
    gap: 16,
    ...Platform.select({
      web: { minHeight: '100vh' } as any,
    }),
  },
  left: {
    flex: 1,
    backgroundColor: Colors.role.canvas,
    borderRadius: 2,
    alignItems: 'center',
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  topBarContainer: {
    width: '100%',
  },
  formCenter: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  formWrapper: {
    width: 340,
  },
  right: {
    flex: 1,
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    fontSize: 12,
    color: Colors.role.textSecondary,
    fontFamily: 'Inter',
    marginTop: 16,
  },
});
